export const GET_LINK_PAYMENT_STATUS_DEF= "GET_LINK_PAYMENT_STATUS_DEF"
export const GET_LINK_PAYMENT_STATUS_DEF_SUCCESS = "GET_LINK_PAYMENT_STATUS_DEF_SUCCESS"
export const GET_LINK_PAYMENT_STATUS_DEF_FAIL = "GET_LINK_PAYMENT_STATUS_DEF_FAIL"

export const LINK_PAYMENT_STATUS_DEF_API_ERROR = "API_ERROR"